import { useSearchParams } from "react-router-dom";
import { useLocalStorageState } from "./useLocalStorageState";
import { useEffect, useMemo } from "react";

type FeatureTypes = {
  address?: "pre-checkout" | null;
};

export const useFeatureGate = () => {
  const [searchParams] = useSearchParams();

  const featureKeys = useMemo(() => {
    const keys: string[] = [];
    searchParams.forEach((value, key) => {
      if (key.startsWith("feature_")) {
        keys.push(key.split("feature_")[1]);
      }
    });
    return keys;
  }, [searchParams]);

  const [features, setFeatures] = useLocalStorageState(
    "features",
    {} as FeatureTypes
  );

  useEffect(() => {
    if (featureKeys.length) {
      if (featureKeys.includes("clear")) {
        setFeatures({});
      } else {
        setFeatures((features) => ({
          ...features,
          ...Object.fromEntries(
            featureKeys.map((key) => {
              const value = searchParams.get("feature_" + key);
              return [
                key,
                value === "true" ? true : value === "false" ? false : value,
              ];
            })
          ),
        }));
      }
    }
  }, [featureKeys, searchParams, setFeatures]);

  return features;
};
